
import Oidc from 'oidc-client';
import AppConfig from '../config';
import api from './api';
import axios from 'axios';

var authApi = {};

Oidc.Log.logger = console;
Oidc.Log.level = Oidc.Log.DEBUG;
console.log('Using oidc-client version: ', Oidc.Version);
var baseurl = window.location.origin;

authApi.state = {
    logged: false,
    user: null,
};

var mgr = null;
authApi.init = () => {
    mgr = new Oidc.UserManager({
        authority: AppConfig.auth.baseUrl,
        client_id: AppConfig.auth.client_id,
        client_secret: AppConfig.auth.client_secret,
        redirect_uri: baseurl + '',
        post_logout_redirect_uri: baseurl + '',
        response_type: "id_token token",
        // response_type: "code",
        scope: 'openid',
        silent_redirect_uri: baseurl + "/auth/silent.html",
        automaticSilentRenew: true,
        validateSubOnSilentRenew: true,
        filterProtocolClaims: true,
        loadUserInfo: true,
        revokeAccessTokenOnSignout : true
    });
    window.mgr = mgr;
    let auth = localStorage.getItem('auth')
    if(auth){
        let authparse = JSON.parse(auth)
        if(authparse)authApi.auth = authparse
    }
}

authApi.accessToken = null;
authApi.auth = {
    logged: false,
    user:{
        FirstName: '',
        LastName: '',
    }
}
authApi.init();
authApi.login = () => {
    return new Promise((resolve, reject) => {
        mgr.signinRedirect({ state: 'clean' })
        .then(console.log)
        .catch(console.error);
    });
}
authApi.resetPassword = () => {
    window.location.href = AppConfig.auth.baseUrl + '/Account/ForgotPassword';
}
authApi.login_old = (email, password) => {

    return new Promise((resolve, reject) => {
        authApi.post('/connect/token', {
            grant_type: 'password',
            username: email,
            password: password,
            client_secret: AppConfig.auth.client_secret,
            client_id: AppConfig.auth.client_id,
            scope: 'openid profile',

        }).then(res => {
            authApi.accessToken = res.data.access_token;
            let auth = {
                logged: true,
                token: {
                    accessToken: authApi.accessToken,
                    expiresAt: Math.floor(Date.now() / 1000) + res.data.expires_in
                }
            }
            authApi.auth = auth
            localStorage.setItem('auth', JSON.stringify(auth))
            authApi.get('/connect/userinfo')
            .then(res2 => {
                authApi.auth.user = res2.data;
                localStorage.setItem('auth', JSON.stringify(auth))
                resolve(res2.data);
            })
            
        })
        mgr.signinRedirect({ state: 'clean', extraQueryParams:{username: email, password: password, client_secret: AppConfig.auth.client_secret, grant_type: 'password'}})
        .then(console.log)
        .catch(console.error);
    });
}

authApi.createAccount = () => {
    window.location.href = AppConfig.auth.baseUrl + '/Account/Register';
}


authApi.check = () => {
    return new Promise((resolve, reject) => {
        if (window.location.href.indexOf('token=') != -1) {
            mgr.signinRedirectCallback()
            .then((user) => {
                authApi.auth.logged = true;
                authApi.auth.user = user.profile;
                authApi.auth.token = {
                    accessToken: user.access_token,
                    expiresAt: user.expires_at
                }
                resolve(authApi.auth);
            })
            .catch((err) => {
                console.error(err);
                authApi.auth.logged = false;
                authApi.auth.user = null;
                mgr.removeUser();
                mgr.clearStaleState();
                reject(authApi.auth);
            });
        } else {
            mgr.getUser().then((user) => {
                authApi.auth.logged = true;
                authApi.auth.user = user.profile;
                authApi.auth.token = {
                    accessToken: user.access_token,
                    expiresAt: user.expires_at
                }
                resolve(authApi.auth);
            }).catch((err) => {
                authApi.auth.logged = false;
                authApi.auth.user = null;
                mgr.removeUser();
                mgr.clearStaleState();
                reject(authApi.auth);
            });
        }
    });
}

authApi.check_old = () => {
    return new Promise((resolve, reject) => {
        mgr.getUser().then((user) => {
            authApi.state.logged = true;
            authApi.state.user = user.profile;
            resolve(authApi.state);
        }).catch((err) => {
            authApi.state.logged = false;
            authApi.state.user = null;
            mgr.removeUser();
            mgr.clearStaleState();
            reject(authApi.state);
        });
    });
}

authApi.logout = () => {
    return new Promise((resolve, reject) => {
        mgr.signoutRedirect({ state: 'clean' })
        .then(() => {
            authApi.state.logged = false;
            authApi.state.user = null;
            mgr.removeUser();
            mgr.clearStaleState();
            resolve(authApi.state);
        })
        .catch((err) => {
            console.error(err);
            window.location.reload();
            mgr.removeUser();
            mgr.clearStaleState();
            reject(authApi.state);
        });
    });
}

authApi.post = (url, data) => {
    return authApi.sendRequest("POST", url, data);
};
// authApi request get shorthand
authApi.get = (url, data) => {
    return authApi.sendRequest("GET", url, data);
};


authApi.sendRequest = (method, url, data) => {
    if (typeof headers == "undefined") var headers = {};
    let defaultHeaders = {
        // 'Content-Type': 'application/json',
    };
    if(data){
        let form_data = new FormData;
        Object.keys(data).forEach(key => {
            form_data.append(key, data[key]);
        });
        data = form_data;
    }
    headers = {...defaultHeaders, ...headers};
    if(authApi.accessToken){
        headers['Authorization'] = 'Bearer '+authApi.accessToken;
    }
    url = AppConfig.auth.baseUrl + url;
    let options = {
        method: method,
        url: url,
        headers: headers,
    };
    if (method.toUpperCase() == 'GET') {
        options.params = data;
    } else {
        options.data = data;
    }
    return new Promise((resolve, reject) => {
        axios(options)
        .then((response) => { resolve(response); })
        .catch((response) => { reject(response); });
    });
};

export default authApi;
